//@config
export default {
  report: {
    payments: "v1/payments",
    my_payments: "v1/my-payments",
    final_report: "v1/final_report",
    final_report_votes: "v1/final_report/{0}/votes",
    final_report_general: "v1/final_report/{0}/general",
    final_report_specialty: "v1/final_report/{0}/specialty",
    final_report_attitude: "v1/final_report/{0}/attitude",
    final_report_intuition: "v1/final_report/{0}/intuition",
    final_report_behavioral: "v1/final_report/{0}/behavioral",
    final_report_resource: "v1/final_report/{0}/resource",
    report_person_result: "v1/report_person_result/{0}",
    final_report_entering_azmoon: "v1/final_report/{0}/entering_azmoon",
    final_report_score: "v1/final_report/{0}/score?group_id={1}",
    final_report_research: "v1/final_report/{0}/research",
    final_report_set_current_parvandeh: "v1/final_report/{0}/see_head_team",
    final_report_see_head_team: "v1/final_report_see_head_team",
    readyReportAccesses: "v1/ready-report-access",
    readyReportAccess: "v1/ready-report-access/{0}",
    readyReportAccessClone: "v1/ready-report-access/{0}/clone",
    readyReportAccessReadyReport: "v1/ready-report-access/{0}/ready-report/{1}",
    ready_report_combo: "v1/ready_report_combo",
    final_report_images: "v1/final_report_images?parvandeh_code={0}",
    ready_qualification: "v1/ready_qualification",
    final_report_exam_pack_parvandeh: "v1/final_report/{0}/exam_pack",
    final_report_exam_pack: "v1/final_report_exam_pack",
    final_report_exam_pack_id: "v1/final_report_exam_pack/{0}",
    final_report_inquiry: "v1/final_report/{0}/inquiry",
    final_report_status: "v1/final_report/{0}/status",
    person_education: "v1/person/{0}/education",
    research_exam_packs: "v1/final_report/{0}/selected_exam_pack",
    research_summary: "v1/research_summary/{0}",
    final_report_research_summary: "v1/final_report/{0}/research_summary",
    final_report_exception: "v1/final_report_exception",
    final_report_conclusion: "v1/final_report/{0}/conclusion",
    payment_no_need: "v1/payment_no_need",
    payment_no_need_id: "v1/payment/{0}/payment_no_need",
    payment_no_need_id_code: "v1/payment/{0}/payment_no_need/{1}",
    company_parvandeh_report: "v1/company_parvandeh_report",
    summary_parvandeh: "v1/summary_parvandeh",
    competency_washup_scores: "v1/competency_washup_scores",
    dashboard_report: "v1/dashboard_report",
    dashboard_report_type: "v1/dashboard_report_type",
    summaryParvandehExport: "v1/summary_parvandeh_export",
    jobsLog: "v1/jobs-log",
    myJobsLog: "v1/my-jobs-log",
    jobsLogStep: "v1/jobs-log/{0}/step",
    exportMain: "v1/export/mine",
    attachmentDownload: "v1/attachment/download/{0}",
    attachmentDownload2: "v1/attachment/download_file/{0}",
    readyReports: "v1/ready_report",
    readyReport: "v1/ready_report/{0}",
    readyReportExport: "v1/export/ready_report",
    competencyMatrixes: "v1/competency-matrix",
    competencyMatrix: "v1/competency-matrix/{0}",
    competencyMatrixDetail: "v1/competency-matrix-detail/{0}",
    competencyMatrixIndicator: "v1/competency-matrix/{0}/indicator",
    readyCommitments: "v1/ready-commitment",
    commitment: "v1/commitment",
    changeCommitmentManager: "v1/commitment/{0}/change-commitment-manager",
    myResponsibilityCommitments: "v1/my-responsibility-commitments",
    myResponsibilityCommitment: "v1/my-responsibility-commitments/{0}",
    myResponsibilityCommitmentsSendMessage:
      "v1/my-responsibility-commitments/{0}/send-message",
    myResponsibilityCommitmentsSendConfirmCode:
      "v1/my-responsibility-commitments/{0}/send-confirm-code",
    myResponsibilityCommitmentsConfirm:
      "v1/my-responsibility-commitments/{0}/confirm",
    dashboardStrategic: "v1/dashboard-strategic",
    myVoices: "v1/my-voice",
    myVoice: "v1/attachment-parvandeh-voice",
    myVoiceId: "v1/attachment-parvandeh-voice/{0}",
    parvandehDescriptiveCenterExecute:
      "v1/parvandeh/{0}/descriptive-center-execute",
    reportAccess: "v1/report-access",
    reportAccessDetail: "v1/report-access/{0}",
    reportAccessParvandeh: "v1/report-access/parvandeh/{0}",
    reportAccessCode: "v1/report-access/{0}/detail",
    parvandehWavePersonalityTestInterpretation:
      "v1/parvandeh/{0}/wave-personality-test-interpretation",
    reportAccessSelectedParvandehList: "v1/report-access/{0}/parvandeh",
    reportAccessUnselectedParvandehList: "v1/report-access/{0}/parvandeh-list",
    reportAccessParvandehId: "v1/report-access/{0}/parvandeh/{1}",
    reportAccessRole: "v1/report-access/{0}/role",
    reportAccessCloneAccess: "v1/report-access/{0}/clone-access",
    termDashboardParvandeh: "v1/term-dashboard/{0}/parvandeh",
    termDashboardPayment: "v1/term-dashboard/{0}/payment",
    termDashboardPaymentByProvince: "v1/term-dashboard/{0}/payment-by-province",
    termDashboardProfileByJobExperienceAge:
      "v1/term-dashboard/{0}/profile-by-job-experience-age",
    termDashboardProfileByYearsOfServiceAge:
      "v1/term-dashboard/{0}/profile-by-years-of-service-age",
    termDashboardProfileByMoarefGender:
      "v1/term-dashboard/{0}/profile-by-moaref-gender",
  },
};
